export default "__VITE_ASSET__snnRvVOh__"